import {
  Box, Paper, Typography,
} from '@mui/material';
import style from './style';

type Props = {
  icon: JSX.Element,
  title: string,
  amount: number | string,
}

export default function StatisticCard({
  icon, title, amount,
}: Props): JSX.Element {
  return (
    <Paper sx={ style.main.sx }>
      <Box sx={ style.box }>
        { icon }
        <Typography
          color="textPrimary"
          variant={ style.amount.variant }
          sx={ style.amount.sx }
        >
          { amount }
        </Typography>
      </Box>
      <Typography
        color={ style.title.color }
        variant={ style.title.variant }
      >
        { title }
      </Typography>
    </Paper>
  );
}
